<script lang="ts" setup>
import HistoryFinancesList from "@/components/history/HistoryFinancesList.vue";
import { useHistoryFinances } from "@/composables/history/useHistoryFinances";
import BaseIcon from "@/components/base/BaseIcon.vue";

const {
  activeCategory,
  activeTab,
  categoryTotals,
  choosePeriod,
  filteredOperations,
  formatInternalName,
  isCustomPeriod,
  isOpenedSelect,
  openSelect,
  operationsTabs,
  periodOptions,
  periodText,
  progressBarSegments,
  selectTab,
  toggleCategory,
  totalSum,
  visibleCategoryTabs,
  selectedPeriod,
} = useHistoryFinances();

const tabClasses = (active: boolean) => {
  return active ? "active" : "";
};
</script>

<template>
  <div class="history-body__summary">
    <div class="history-body__summary-header">
      <div class="history-body__summary-header_period" @click.stop="openSelect">
        <p class="caption-large--bold color-grey-light">
          {{ periodText }}
        </p>
        <div class="arrow-box color-grey-light">
          <BaseIcon
            v-if="isCustomPeriod"
            name="close"
            @click.stop="selectedPeriod = 'year'"
          />
          <BaseIcon
            v-else
            name="service-arrow"
            :position="isOpenedSelect ? 'top' : 'bottom'"
            @click.stop="openSelect"
          />
        </div>
        <div class="period-select" :class="{ open: isOpenedSelect }">
          <div
            v-for="option in periodOptions"
            :key="option.value"
            class="period-select__item"
            @click.stop="choosePeriod(option.value)"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
      <div class="history-body__summary-header_tabs">
        <div
          v-for="(item, index) in operationsTabs"
          :key="index"
          class="history-body__summary-header_tabs-item"
          :class="tabClasses(item.active)"
          @click="selectTab(item.key)"
        >
          <p class="caption-navbar color-grey-light">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="history-body__summary-sum">
      <p class="h1">{{ totalSum }} ₽</p>
    </div>
    <div class="history-body__summary-progressBar">
      <template v-if="progressBarSegments.length > 0">
        <div
          v-for="seg in progressBarSegments"
          :key="seg.key"
          class="progress-segment"
          :class="`--${seg.key}`"
          :style="{ width: seg.percent + '%' }"
        ></div>
      </template>
      <template v-else>
        <div class="progress-empty"></div>
      </template>
    </div>
    <div class="history-body__summary-categories">
      <div
        v-for="cat in visibleCategoryTabs"
        :key="cat.key"
        class="history-body__summary-categories_tab"
        :class="{ active: activeCategory === cat.key }"
        @click="toggleCategory(cat.key)"
      >
        <div class="marker" :class="`--${cat.key}`"></div>
        <p class="caption-small--semi-bold">
          {{ cat.label }}
          <span class="caption-small--bold"
            >{{ categoryTotals[cat.key] }} ₽</span
          >
        </p>
      </div>
    </div>
  </div>
  <!-- key по вкладке и категории: список пересобирается кроссфейдом -->
  <Transition name="tab" mode="out-in">
    <HistoryFinancesList
      :key="`${activeTab}-${activeCategory ?? 'all'}`"
      :operations="filteredOperations"
      :format-internal-name="formatInternalName"
    />
  </Transition>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/history-finances";
</style>
